import RefundSummaryView from '@/components/refund/RefundSummaryView';
import {
  type AdmissionDTO,
  type BookedAncillaryDTO,
  type RefundOffersDTO,
} from '@/types/dto/agent';
import { type FC } from 'react';

interface RefundSummaryProps {
  refundSummary: RefundOffersDTO;
  admissions?: Array<AdmissionDTO>;
  ancillaries?: Array<BookedAncillaryDTO>;
}

const RefundSummary: FC<RefundSummaryProps> = ({
  refundSummary: { refundOffers },
  admissions = [],
  ancillaries = [],
}) => {
  const { refundableAmount, refundFee } = refundOffers?.[0] ?? {};

  const totalAmount = ancillaries.length
    ? ancillaries
        .filter((ancillary) => ancillary.status !== 'REFUNDED')
        .reduce((sum, ancillary) => sum + (ancillary.price?.amount ?? 0), 0)
    : admissions.reduce((sum, admission) => {
        const admissionPrice = admission.price?.amount ?? 0;
        const ancillariesPrice =
          admission.ancillaries
            ?.filter((ancillary) => ancillary.status !== 'REFUNDED')
            .reduce(
              (acc, ancillary) => acc + (ancillary.price?.amount || 0),
              0
            ) || 0;

        return sum + admissionPrice + ancillariesPrice;
      }, 0);

  return (
    <RefundSummaryView
      totalPrice={totalAmount}
      refundFee={refundFee?.amount ?? 0}
      refundAmount={refundableAmount?.amount}
    />
  );
};

export default RefundSummary;
